import { render, staticRenderFns } from "./regulDbUploadDetail.vue?vue&type=template&id=deccdc86"
import script from "./regulDbUploadDetail.vue?vue&type=script&lang=js"
export * from "./regulDbUploadDetail.vue?vue&type=script&lang=js"
import style0 from "./regulDbUploadDetail.vue?vue&type=style&index=0&id=deccdc86&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('deccdc86')) {
      api.createRecord('deccdc86', component.options)
    } else {
      api.reload('deccdc86', component.options)
    }
    module.hot.accept("./regulDbUploadDetail.vue?vue&type=template&id=deccdc86", function () {
      api.rerender('deccdc86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/db/regulDbUploadDetail.vue"
export default component.exports